"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultPreviewEmailPayloadSchema = exports.AssignmentConfirmationJobPayloadSchema = exports.ReceivableResponseTapePreviewsFromStrategyPayloadSchema = exports.SingleReceivableResponseTapePreviewPayloadSchema = exports.BalanceSheetImpactCalculations = exports.Assignment = exports.ReceivableResponseTapePreviewJobs = exports.Preview = exports.CreditFacility = exports.ReceivableBaseFieldsSchema = exports.AssignmentExclusionSchema = exports.AssignmentExclusionIterable = exports.AssignmentFieldsSchema = exports.receivableRetroEvent = exports.ReceivableStatus = exports.ReceivableStatusIterable = void 0;
// Re-export common types and values
var common_1 = require("./common");
Object.defineProperty(exports, "ReceivableStatusIterable", { enumerable: true, get: function () { return common_1.ReceivableStatusIterable; } });
Object.defineProperty(exports, "ReceivableStatus", { enumerable: true, get: function () { return common_1.ReceivableStatus; } });
Object.defineProperty(exports, "receivableRetroEvent", { enumerable: true, get: function () { return common_1.receivableRetroEvent; } });
Object.defineProperty(exports, "AssignmentFieldsSchema", { enumerable: true, get: function () { return common_1.AssignmentFieldsSchema; } });
Object.defineProperty(exports, "AssignmentExclusionIterable", { enumerable: true, get: function () { return common_1.AssignmentExclusionIterable; } });
Object.defineProperty(exports, "AssignmentExclusionSchema", { enumerable: true, get: function () { return common_1.AssignmentExclusionSchema; } });
Object.defineProperty(exports, "ReceivableBaseFieldsSchema", { enumerable: true, get: function () { return common_1.ReceivableBaseFieldsSchema; } });
// Re-export namespaces as modules
exports.CreditFacility = __importStar(require("./CreditFacility"));
exports.Preview = __importStar(require("./Preview"));
exports.ReceivableResponseTapePreviewJobs = __importStar(require("./ReceivableResponseTapePreviewJobs"));
exports.Assignment = __importStar(require("./Assignment"));
exports.BalanceSheetImpactCalculations = __importStar(require("./BalanceSheetImpactCalculations"));
// Re-export schemas that are used at the top level of the original file
const zod_1 = require("zod");
const Utils_1 = require("../Utils");
const Assignment = __importStar(require("./Assignment"));
exports.SingleReceivableResponseTapePreviewPayloadSchema = zod_1.z.object({
    creditFacilityId: zod_1.z.string(),
    masterLoanTapeIds: zod_1.z.array(zod_1.z.string()),
    previewIdentifier: zod_1.z.string(),
    receivableResponseTapePreviewJobId: zod_1.z.string(),
});
exports.ReceivableResponseTapePreviewsFromStrategyPayloadSchema = zod_1.z.object({
    assignmentStrategyId: zod_1.z.string(),
    masterLoanTapeIds: zod_1.z.array(zod_1.z.string()),
    receivableResponseTapePreviewJobId: zod_1.z.string(),
});
exports.AssignmentConfirmationJobPayloadSchema = zod_1.z.object({
    assignmentConfirmationJobId: zod_1.z.string(),
    jobType: Assignment.AssignmentConfirmationJob.AssignmentConfirmationJobTypeSchema,
});
exports.DefaultPreviewEmailPayloadSchema = zod_1.z.object({
    loanProductIds: zod_1.z.array(zod_1.z.string()),
    implementationId: zod_1.z.string(),
    fileVersion: zod_1.z.number(),
    reportingDate: Utils_1.ZodFullDateStrForJsonSchemaStruct,
});
//# sourceMappingURL=index.js.map